import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import formatDistance from 'date-fns/formatDistance';
import parseISO from 'date-fns/parseISO';
import { global } from '../../utils';
const TimeDistance = ({ timestamp }) => {
    const [delay, setDelay] = useState(5);
    let td = '';
    useEffect(() => {
        const nextDelay = delay <= 60 ? delay + 1 : 60;
        const timeoutId = setTimeout(() => setDelay(nextDelay), delay * 1000);
        return () => clearInterval(timeoutId);
    }, [delay, timestamp]);
    if (timestamp === undefined || timestamp === '') {
        return _jsx(_Fragment, { children: global.NOT_AVAILABLE }, void 0);
    }
    try {
        td = formatDistance(parseISO(timestamp), new Date(), {
            addSuffix: true,
            includeSeconds: true,
        });
    }
    catch (_a) {
        console.error('failed timestamp error:', timestamp);
    }
    return _jsx(_Fragment, { children: td }, void 0);
};
export default TimeDistance;
